/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Retry policy configuration for a Spark job
*/
export class SparkJobRetryPolicy {
  /**
  * Maximum number of retry attempts
  */
  'maxAttempts'?: number;
  /**
  * Maximum number of failed attempts allowed per hour
  */
  'maxFailedAttemptsPerHour'?: number;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "maxAttempts",
      "baseName": "maxAttempts",
      "type": "number",
      "format": ""
    },
    {
      "name": "maxFailedAttemptsPerHour",
      "baseName": "maxFailedAttemptsPerHour",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SparkJobRetryPolicy.attributeTypeMap;
  }

  public constructor() {
  }
}

